import React, { useEffect } from "react";
import styled from "styled-components";
import "react-spring-bottom-sheet/dist/style.css";
import ProfileDownloadIcon from "../mobile/ProfileDownloadIcon";
import mobile from "../../assets/mobile.png";

const Container = styled.div`
  border-radius: 8px;
  height: 100vh;
  background: linear-gradient(254.06deg, #59c5e8 -33.43%, #5a8ef1 113.89%);
  overflow: hidden;
  padding: 36px 32px;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
`;

const Button = styled.a`
  background: white;
  padding: 8px 16px;
  border-radius: ${(props) => (props.rounded ? "10000px" : "4px")};
  font-size: 14px;
  color: #59a1ee;
`;

export default function BlueSticker(props) {
  return (
    <Container>
      <ProfileDownloadIcon img={props.user.pictureUri} />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: 'center',
          height: '83%',
        }}
      >
        <div>
          <span>Explore more clips by @{props.user.username}</span>
          <br></br>
          <br></br>
          <span style={{ opacity: 0.7, fontSize: 12 }}>
            Join ggTV community<br></br>
            to browse, create & share<br></br> gaming clips
          </span>
          <br></br>
          <br></br>
          <br></br>
          <Button
            rounded
            onClick={() => {
              window.analytics.track('download_button_pressed', {
                from: 'side-banner',
                type: 'desktop'
              }) 
            }}
            href={
              "https://play.google.com/store/apps/details?id=glip.gg&hl=en_IN&gl=US"
            }
          >
            Download android app
          </Button>
        </div>
        <img style={{width: '125%'}} src={mobile} />
      </div>
    </Container>
  );
}
